import { computed, inject, toRefs } from "vue";
import { createError, useRoute } from "nuxt/app";
import { debugStamp, errorStamp } from "../helpers/logging.js";
import { MAIN_PAGE } from "../consts/injectProvideKeys.js";
const DEBUG = false;
export function useBrxmData(props, componentName) {
  const { component, page } = toRefs(props);
  const document = computed(() => {
    debugStamp(DEBUG, `[USE_BRXM_DATA] - component: ${componentName}`);
    const componentDocument = component?.value?.getModels().document;
    if (!componentDocument) {
      debugStamp(DEBUG, `[USE_BRXM_DATA] - no document's data in component's model`);
      return;
    }
    const contentFromPage = page?.value?.getContent(componentDocument);
    if (contentFromPage) {
      return contentFromPage;
    }
    debugStamp(DEBUG, `[USE_BRXM_DATA] - no content in page from props, searching in injection...`);
    const parentPage = inject(MAIN_PAGE);
    if (!parentPage) {
      debugStamp(DEBUG, `[USE_BRXM_DATA] - no data from injection:`, parentPage);
      return null;
    }
    const contentFromParentPage = parentPage?.getContent(componentDocument);
    if (!contentFromParentPage) {
      debugStamp(
        DEBUG,
        `[USE_BRXM_DATA] - no content in injected data (maybe parentPage isn't from highest level):`,
        parentPage
      );
      return null;
    }
    return contentFromParentPage;
  });
  const data = computed(() => {
    const tmp = document.value?.getData();
    if (!tmp) {
      errorStamp(DEBUG, "[USE_BRXM_DATA] - no data returned - DocumentDataModel is empty");
      let pageUrl;
      try {
        pageUrl = page?.value?.getUrl();
      } catch (error) {
        console.log("[USE_BRXM_DATA] - pageUrl error", error);
        pageUrl = `${useRoute().path} (from useRoute)`;
      }
      throw createError({
        statusCode: 500,
        statusMessage: `Page url: ${pageUrl}; Component: ${componentName} - DocumentDataModel is empty`
      });
    }
    return tmp;
  });
  return data;
}
